export default __webpack_public_path__ + "static/media/project2.2f28bc01.png";